var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302,
    height: 178,
    viewBox: "0 0 302 178",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.871094,
    width: 302,
    height: 177,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9409 75.3889C77.488 73.9367 75.5948 73.0643 73.4183 72.7303C73.0848 70.5539 72.2123 68.6608 70.7602 67.2074C60.9785 57.4257 45.1181 57.4257 35.3364 67.2074C25.5545 76.9892 25.5545 92.8501 35.3364 102.632C36.7893 104.085 38.6825 104.957 40.859 105.292C41.1925 107.468 42.065 109.361 43.5171 110.813C53.2988 120.595 69.16 120.595 78.9409 110.813C88.7242 101.032 88.7242 85.1719 78.9409 75.3889Z",
    fill: "url(#paint0_linear_236_269)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9678 82.8376C57.9041 75.9015 66.3175 72.4055 72.4011 73.3403C72.0843 71.2729 71.2554 69.4746 69.876 68.094C64.4337 62.6524 52.4887 65.773 43.1973 75.066C33.9048 84.3578 30.7828 96.3023 36.2248 101.744C37.605 103.125 39.4035 103.952 41.4711 104.27C40.5338 98.1866 44.0315 89.7738 50.9678 82.8376Z",
    fill: "url(#paint1_radial_236_269)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.743 101.901C124.588 101.901 129.174 99.392 130.861 94.4602L125.367 93.5513C124.372 95.368 122.425 96.5801 120.046 96.5801C116.498 96.5801 113.946 93.8978 113.946 90.1339C113.946 86.37 116.498 83.6877 120.046 83.6877C122.382 83.6877 124.329 84.8988 125.194 86.7586L130.688 85.8508C129.088 80.9622 124.761 78.3662 119.743 78.3662C112.778 78.3662 107.846 83.298 107.846 90.1339C107.846 96.9687 112.778 101.901 119.743 101.901Z",
    fill: "#19191A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.796 110.342H150.334V101.56C157.386 101.56 162.361 96.8012 162.361 90.0959C162.361 83.3896 157.386 78.6736 150.334 78.6736V70.9731H144.796V78.6736C137.788 78.6736 132.812 83.3896 132.812 90.0959C132.812 96.8012 137.788 101.56 144.796 101.56V110.342ZM144.796 96.5853C141.249 96.5853 138.783 93.9462 138.783 90.0959C138.783 86.2878 141.249 83.6497 144.796 83.6497V96.5853ZM150.334 96.5853V83.6497C153.925 83.6497 156.391 86.2878 156.391 90.0959C156.391 93.9462 153.925 96.5853 150.334 96.5853Z",
    fill: "#19191A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.016 89.7874C189.016 83.3844 184.084 78.3662 177.075 78.3662C170.11 78.3662 165.135 83.298 165.135 90.1339C165.135 96.9687 170.067 101.901 176.989 101.901C181.791 101.901 186.463 99.6079 188.02 95.1953L182.526 94.2864C181.488 95.7576 179.671 96.7097 177.334 96.7097C173.917 96.7097 171.667 94.7192 171.105 91.6472H188.929C188.972 91.1281 189.016 90.4793 189.016 89.7874ZM177.075 83.2549C179.801 83.2549 181.877 85.0283 182.656 87.4516H171.408C172.23 84.942 174.35 83.2549 177.075 83.2549Z",
    fill: "#19191A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.668 110.337H198.508V98.2241C200.065 99.9544 202.921 101.901 206.772 101.901C213.261 101.901 217.803 96.9687 217.803 90.1339C217.803 83.298 213.261 78.3662 206.772 78.3662C202.704 78.3662 199.72 80.5293 198.249 82.346L197.21 78.7991H192.668V110.337ZM205.171 96.7097C201.233 96.7097 198.508 93.941 198.508 90.1339C198.508 86.3268 201.233 83.5571 205.171 83.5571C209.064 83.5571 211.703 86.3268 211.703 90.1339C211.703 93.941 209.064 96.7097 205.171 96.7097Z",
    fill: "#19191A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.71 110.334H226.555C231.141 110.334 233.781 108.3 235.251 103.584L243.039 78.7954H237.112L231.833 95.9699H230.795L224.825 78.7954H218.639L226.902 101.465H230.146L229.8 102.59C229.237 104.407 228.545 105.012 227.031 105.012H221.234L221.71 110.334Z",
    fill: "#19191A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.451 101.465H251.989V85.804H252.767L258.045 101.465H262.501L268.083 85.804H268.818V101.465H274.355V78.7954H265.746L260.814 92.899H260.036L255.276 78.7954H246.451V101.465Z",
    fill: "#19191A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_269",
    x1: 38.8719,
    y1: 104.995,
    x2: 75.0151,
    y2: 73.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1277,
    stopColor: "#2006C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#4A0EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5106,
    stopColor: "#6B14C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6905,
    stopColor: "#8318C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#911BC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#961CC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_236_269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0589 95.397) rotate(-128.973) scale(21.0704 31.0775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B25CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    stopColor: "#2C93DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#42DCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BF9E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor4);
export default __webpack_public_path__ + "static/media/Sponsor4.caf8643a6e5be65bcd4e13ca122c1ee1.svg";
export { ForwardRef as ReactComponent };